export default __webpack_public_path__ + "static/screenFourthSectionEn-1c936049a83be311f020cc4c770a9cf8.webp";